import React, { useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import Reveal from '../components/Reveal';
import TypedCommand from '../components/TypedCommand';
import { track } from '../lib/track';

const featured = [
  {
    kicker: 'Agentic Commerce',
    title: 'Meshyay',
    body: 'A commerce platform whose back office is run by AI agents bounded by an explicit autonomy register in code, with autonomous USDC supplier payouts.',
    violet: true
  },
  {
    kicker: 'Multi-Agent Systems',
    title: 'Keepsake',
    body: 'A voice-first memory companion for dementia care, run by ten cooperating agents — every safety-critical decision made by code, not a prompt.',
    violet: true
  },
  {
    kicker: 'Shipped Product',
    title: 'Tijarat360',
    body: 'A full-stack B2B agricultural marketplace with smart-contract escrow, live on web, Android, and iOS.',
    violet: false
  }
];

const Home: React.FC = () => {
  const [typed, setTyped] = useState(false);
  return (
  <IonPage>
    <IonContent>
      <SiteNav current="/home" />
      <main className="page">
        <TypedCommand command="whoami" onDone={() => setTyped(true)} />
        <div style={{ opacity: typed ? 1 : 0, transition: 'opacity 0.5s ease' }}>
        <section className="section">
          <Reveal>
            <p className="comment">Senior Software Engineer &mdash; Backend &amp; Applied AI</p>
            <h1 className="display" style={{ marginTop: '0.75rem' }}>
              Mujahid<span className="hl"> Masood</span>
              <span className="cursor" />
            </h1>
            <p className="lede">
              A decade of building backend systems that stay up &mdash; <strong>Kotlin and Java services
              on AWS and Kubernetes</strong>, from enterprise microservices to IoT platforms ingesting
              live sensor data. Today I also design and ship <strong>applied-AI systems</strong>:
              multi-agent fleets with coded safety guardrails, agent systems whose authority is
              bounded in code, and voice-first products deployed to real users.
            </p>
            <div className="btn-row">
              <a className="btn btn--primary" href="/projects">See AI projects</a>
              <a className="btn btn--ghost" href="/experience">View experience</a>
              <a
                className="btn btn--ghost"
                href="/Mujahid_Masood_Resume.pdf"
                download="Mujahid_Masood_Resume.pdf"
                onClick={() => track('cv_download', { source: 'hero' })}
              >
                Download CV ⇩
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="stat-row">
              <div className="stat">
                <div className="stat__value">10<span>+</span></div>
                <div className="stat__label">Years full-time since 2011</div>
              </div>
              <div className="stat">
                <div className="stat__value">10<span>-agent</span></div>
                <div className="stat__label">Fleet shipped to production</div>
              </div>
              <div className="stat">
                <div className="stat__value">3<span>&times;</span></div>
                <div className="stat__label">Apps live on Play Store &amp; App Store</div>
              </div>
              <div className="stat">
                <div className="stat__value">2<span></span></div>
                <div className="stat__label">Degrees &mdash; MSc TU Darmstadt</div>
              </div>
            </div>
          </Reveal>
        </section>

        <section className="section">
          <Reveal>
            <p className="section-label"><em>ls</em> ~/projects --featured</p>
          </Reveal>
          <div className="card-grid">
            {featured.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.08}>
                <a href="/projects" style={{ textDecoration: 'none' }}>
                  <div className={`card ${item.violet ? 'card--violet' : 'card--accent'}`} style={{ height: '100%' }}>
                    <span className="card__kicker">{item.kicker}</span>
                    <h2 className="card__title">{item.title}</h2>
                    <p className="card__body">{item.body}</p>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </section>

        <section className="section">
          <Reveal>
            <p className="section-label"><em>ps</em> aux | grep current-role</p>
            <p className="lede" style={{ marginBottom: 0 }}>
              Software Engineer at <strong>beyonnex.io</strong> (Hamburg, remote) &mdash; building the
              cloud-native backend of an IoT energy-metering platform with Kotlin, Quarkus, Kubernetes,
              and AWS IoT Core. Open to senior backend and applied-AI roles.
            </p>
          </Reveal>
        </section>

        <SiteFooter />
        </div>
      </main>
    </IonContent>
  </IonPage>
  );
};

export default Home;
